import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthMedium } = breakpoints;
const S = {};

S.PlanItem = styled.li`
  label: PlanItem;

  --shadow-color: var(--colors-alabaster);
  background-color: var(--colors-white);
  box-shadow: inset 0 0 0 0.3125rem var(--shadow-color);
  transition: box-shadow 0.1s ease-in-out;
  padding: 1.5rem 0;
  text-align: center;
  cursor: pointer;

  &:hover {
    --shadow-color: var(--colors-orange-bright);
  }

  &.active {
    --shadow-color: var(--colors-orange-base);
  }

  @media (${widthMedium}) {
    padding-top: 4rem;
    height: 13.25rem;
  }
`;

S.PlanItem.Savings = styled.div`
  label: Savings;

  color: var(--colors-orange-base);
  text-transform: uppercase;
  margin-top: 0.5rem;

  @media (${widthMedium}) {
    margin-top: 1rem;
  }
`;

S.PlanItem.Title = styled.h1`
  label: Title;

  margin-bottom: 0.25rem;
  text-transform: capitalize;

  @media (${widthMedium}) {
    margin-bottom: 0.5rem;
  }
`;

S.PlanItem.Subtitle = styled.span`
  label: Subtitle;
  text-transform: uppercase;
  color: ${({ hasSavings }) =>
    hasSavings ? 'var(--colors-scarpa-flow)' : 'var(--colors-black)'};
  display: inline-block;
`;

S.PlanItem.EqualSign = styled.span`
  label: EqualSign;

  margin: 0 0.1875rem;
`;

export default S;
